export const SET_RELATIONSHIPS = 'SET_RELATIONSHIPS';
export const RESET_RELATIONSHIPS = 'RESET_RELATIONSHIPS';
export const RELATIONSHIPS_HAS_ERRORED = 'RELATIONSHIPS_HAS_ERRORED';
export const RELATIONSHIPS_IS_LOADING = 'RELATIONSHIPS_IS_LOADING';
export const RELATIONSHIPS_FETCH_DATA_SUCCESS = 'RELATIONSHIPS_FETCH_DATA_SUCCESS';
